export default __webpack_public_path__ + "static/media/Clothes - Girls.a3d42641.jpg";